import { Injectable } from '@angular/core';
import { User, UserManager } from 'oidc-client';
import { ApiService } from './api.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  signingKeys: any;
  userManager!: UserManager;

  constructor(
    private readonly apiService: ApiService
  ) { }

  initialize(linkIdxUrl: string, spaUrl: string) {
    if (!this.signingKeys) {
      this.signingKeys = this.getSigningKeys(linkIdxUrl + '/protocol/openid-connect/certs');
    }

    const settings = {
      authority: linkIdxUrl,
      client_id: 'cd-omui',
      redirect_uri: window.location.href,
      loadUserInfo: false,
      metadata: {
        issuer: linkIdxUrl,
        jwks_uri: linkIdxUrl + '/protocol/openid-connect/certs',
        end_session_endpoint: linkIdxUrl + '/protocol/openid-connect/logout',
        token_endpoint: linkIdxUrl + '/protocol/openid-connect/token',
        token_introspection_endpoint: linkIdxUrl + '/protocol/openid-connect/token/introspect',
        userinfo_endpoint: linkIdxUrl + '/protocol/openid-connect/userinfo',
        authorization_endpoint: linkIdxUrl + '/protocol/openid-connect/auth',
      },
      signingKeys: this.signingKeys,
      scope: 'openid profile',
      response_type: 'code',
      post_logout_redirect_uri: spaUrl + '/logout',
      post_login_route: spaUrl,
      automaticSilentRenew: true,
      includeIdTokenInSilentRenew: true,
      silent_redirect_uri: spaUrl + 'assets/silent-callback.html',
      accessTokenExpiringNotificationTime: 6000
    };

    this.userManager = new UserManager(settings);  

    this.userManager.events.addUserLoaded((user: User) => {
      localStorage.setItem('currentUser', JSON.stringify(user));
    });  
    
  }

  async getSigningKeys(url: string): Promise<string> {
    const result = await this.apiService.get<string>('Getting signing keys', url)    
    return JSON.stringify(result ?? '{}');
  }

  async isLoggedIn(): Promise<Boolean | undefined> {
    return this.userManager.getUser().then((user: User | null) => {
      return !!user && !user.expired;
    });
  }

  async completeLogin() {
    const user = await this.userManager.signinRedirectCallback();
    
    if (user.profile.preferred_username && user.profile.preferred_username.indexOf('_') > -1) {
      user.profile.preferred_username = user.profile.preferred_username.substring(0, user.profile.preferred_username.indexOf('_'));
    }

    localStorage.setItem('currentUser', JSON.stringify(user));
    
  }

  async getState(): Promise<string> {
    if (location.href.includes('bypass') || localStorage.getItem('bypass')) {
      return 'Bypass';
    } else if (await this.isLoggedIn() && localStorage.getItem('currentUser') !== null) {
      return 'Logged In'
    } else if (location.href.includes('code=')) {
      return 'Authenticated';
    } else {
      return 'Not authenticated'
    }
  }

  async bypass() {
    const bypassValue = location.href.substring(location.href.indexOf('bypass') + 7);
    localStorage.setItem('bypass', bypassValue);
  }

  async login(): Promise<void> {
    let startTime = new Date();
    localStorage.setItem('startTime', startTime.toString());
    await this.userManager.signinRedirect();
    await new Promise(f => setTimeout(f, 60000));
  }

  async logout() {
    localStorage.clear();
    await this.userManager.signoutRedirect();
  }
}
